import { MANAGED_RULESETS, PHASE } from '../constants.js';
import { SCOPES } from '../scopes.js';
import { managedRuleset } from '../types.js';

/**
 * Managed rulesety wdrażamy jako regułę `execute` w fazie
 * `http_request_firewall_managed`. Na poziomie strefy każdy ruleset można
 * wdrożyć TYLKO RAZ — Etap 4 musi to sprawdzić przed dodaniem.
 *
 * Brak uprawnień do rulesetu objawia się jako 404, NIE 403.
 */

export const managedCloudflareFree = managedRuleset({
  rulesetId: MANAGED_RULESETS.cloudflareFree.id,
  phase: PHASE.firewallManaged,
  refSlug: 'managed_cf_free',
  value: { t: 'bool' },
  staff: {
    label: MANAGED_RULESETS.cloudflareFree.cfName,
    hint: 'Dostępny na każdym planie. Zbędny, jeśli wdrożony jest Cloudflare Managed Ruleset.',
  },
  customer: {
    changePl: (v) =>
      v
        ? 'Włączymy filtr blokujący znane, powszechnie wykorzystywane ataki na strony.'
        : 'Wyłączymy filtr znanych ataków.',
  },
  plans: { min: 'free' },
  scopes: [SCOPES.zoneWafWrite],
});

export const managedCloudflare = managedRuleset({
  rulesetId: MANAGED_RULESETS.cloudflareManaged.id,
  phase: PHASE.firewallManaged,
  refSlug: 'managed_cf',
  value: { t: 'bool' },
  staff: {
    label: MANAGED_RULESETS.cloudflareManaged.cfName,
    hint: 'Od planu Pro. Zawiera pełne pokrycie — wtedy Free Managed Ruleset jest zbędny.',
  },
  customer: {
    changePl: (v) =>
      v
        ? 'Włączymy rozszerzony filtr blokujący znane ataki na strony i sklepy.'
        : 'Wyłączymy rozszerzony filtr znanych ataków.',
  },
  plans: { min: 'pro' },
  scopes: [SCOPES.zoneWafWrite],
});

export const managedOwasp = managedRuleset({
  rulesetId: MANAGED_RULESETS.owaspCore.id,
  phase: PHASE.firewallManaged,
  refSlug: 'managed_owasp',
  value: { t: 'bool' },
  staff: {
    label: MANAGED_RULESETS.owaspCore.cfName,
    hint: 'Od planu Pro. Model punktowy — łatwo o fałszywe alarmy, wymaga strojenia progu.',
  },
  customer: {
    changePl: (v) =>
      v
        ? 'Włączymy dodatkowy, czuły filtr wykrywający nietypowe żądania.'
        : 'Wyłączymy dodatkowy filtr nietypowych żądań.',
  },
  plans: { min: 'pro' },
  scopes: [SCOPES.zoneWafWrite],
  valueNotes: {
    true: {
      severity: 'warn',
      textPl:
        'Filtr punktowy bywa nadgorliwy — potrafi blokować logowanie do panelu, ' +
        'wysyłanie formularzy i wgrywanie plików. Nie włączaj bez uzgodnienia z klientem.',
    },
  },
});
